import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { Locales, MessagePropType } from '@ratehub/base-ui';

import HeroTabContentListItem from './HeroTabContentListItem';


function HeroTabContentListItemContainer({ listItems }) {
    const intl = useIntl();

    return (
        <Container className="rh-height-100p rh-display-grid rh-align-items-center">
            <For
                each="item"
                of={listItems}
                index="index"
            >
                <HeroTabContentListItem
                    key={index}
                    index={index}
                    iconKey={item.iconKey}
                    title={item.title}
                    subtitle={item.subtitle}
                    href={item.href[intl.locale] ?? item.href[Locales.ENGLISH]}
                />
            </For>
        </Container>
    );
}

HeroTabContentListItemContainer.propTypes = {
    listItems: PropTypes.arrayOf(PropTypes.shape({
        iconKey: PropTypes.string.isRequired,
        title: MessagePropType.isRequired,
        subtitle: MessagePropType.isRequired,
        href: PropTypes.shape({
            [Locales.ENGLISH]: PropTypes.string,
            [Locales.FRENCH]: PropTypes.string,
        }),
    })).isRequired,
};

const Container = styled.ul`
    grid-auto-rows: 1fr;
    list-style-type: none;
    padding-inline-start: 0;
`;

export default HeroTabContentListItemContainer;
